import { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Tooltip } from "@mui/material";
import React from "react";


import { SPOCProfileButton } from '../components/SPOCProfileButton'
import { TablePagination } from '../../DoctorMangement/AddDoctor/TablePagination'
import { LastModfiedCell } from '../../DoctorMangement/AddDoctor/LastModfiedCell';
import { logEventToAnalyticsPlatform } from "../../../helper/events"
import { EVENTS } from "../../DoctorMangement/events_Constant"
import { getUrlForSPOCProfilePage } from "../Helper/utils"
import { MenuListComposition } from "./MenuItems"
import UserFeaturesContext  from '../../../hook/UserDetails/UserFeaturesContext'; // Import the context
import { checkFeatureFeasbility } from "../../../helper/utils";
import { FEATURE_NAME } from "../../DoctorMangement/constant";
import { SESSION_STORAGE_KEYS } from '../../../constants/provider/constant';


const headCells = [
  {
    id: 'profile',
    disablePadding: false,
    label: 'SPOC Name & ID',
    minWidth: 300,
  },
  {
    id: 'Access Level',
    disablePadding: false,
    label: 'Access Level',
    minWidth: 135,
  },
  {
    id: 'Profile Status',
    numeric: true,
    disablePadding: false,
    label: 'Profile Status',
    minWidth: 175
  },
  {
    id: 'Services',
    numeric: true,
    disablePadding: false,
    label: 'Services',
    minWidth: 175
  },
  {
    id: 'Department',
    numeric: true,
    disablePadding: false,
    label: 'Department',
    minWidth: 300
  },
  {
    id: 'Provider',
    numeric: true,
    disablePadding: false,
    label: 'Provider',
    minWidth: 300
  },
  {
    id: 'Last Modified',
    disablePadding: false,
    label: 'Last Modified',
    minWidth: 300
  }, 
  {
    id: 'Menu Items',
    disablePadding: false,
    label: '',
    minWidth: 50
  }
];

function EnhancedTableHead(props) {
  const { headCells, totalRecords } = props
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <>
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={'normal'}
              className={`${headCell.id === 'profile' ? 'w-72 sticky left-0 bg-gray-100 bg-opacity-100 z-10 ' : 'bg-gray-100 '} `}
              sx={{ minWidth: headCell.minWidth, 'color': '#596C86', 'fontSize': '12px', 'font-weight': 500, borderRight: '1px solid #ddd', }}
            >
              {headCell.label}{headCell.id === 'profile' ? ` (${totalRecords})` : ' '}
            </TableCell>
          </>
        ))}
      </TableRow>
    </TableHead>
  );
}



export const SPOCListTable = ({ setPage, totalRecords, page, fetchSPOCDetails, ...props }) => {
  const { user } = props.SPOCList;
  const [selected, setSelected] = useState([]);
  const { userFeatures } = useContext(UserFeaturesContext);
  const history = useHistory();

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };


  const handleClickOpen = (id, entityId, userName) => {
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_LS_ACTION.name,
      payload: {
        tab_name: EVENTS.TAB_NAME_LC_SCREEN,
        filterValue: '',
        reference_id: '' + id,
        reference_provider_id: '' + entityId,
        service_name: EVENTS.SERVICE_NAME_SPOC,
        action: EVENTS.ACTION.SPOC_EDIT,
      },
      schema: EVENTS.PC_LS_ACTION.schema,
    })
    const url = getUrlForSPOCProfilePage(id, userName);
    history.push(url);
  };

  const emptyRows = 10 - user.length;

  const getServicesFromRoles = (roles) => {
    const services = roles?.map((item) => {
      const itemRoleNameSplit = item.roleName.split('/*/');
      if (itemRoleNameSplit.length > 1 && itemRoleNameSplit[1].toLowerCase() == 'services') {
        const itemRoleName = itemRoleNameSplit[0].toLowerCase();
        if (itemRoleName.toLowerCase() === 'ofc') return "Offline Consults";
        if (itemRoleName.toLowerCase() === 'labs') return "Labs";
        if (itemRoleName.toLowerCase() === 'vision') return "Vision";
      }
    }).filter(Boolean);
    return services.join(', ');
  }

  const getDepartmentFromRoles = (roles) => {
    const specialityMap = JSON.parse(localStorage.getItem(SESSION_STORAGE_KEYS.SPECIALITY_ARRAY) || '{}');
    const department = roles?.map((item) => {
      const itemRoleNameSplit = item.roleName.split('/*/');
      if (itemRoleNameSplit.length > 1) {
        const roleDept = itemRoleNameSplit[0].split('/');
        if (roleDept.length > 1) {
          let roleLabel = roleDept[1].replaceAll('_', ' ');
          if(roleLabel.includes('^')){
            roleLabel = roleLabel.split('^')[1];
          }
          if (specialityMap[roleLabel]) {
            roleLabel = specialityMap[roleLabel];
          }
            return roleLabel
      }
    }
    }).filter(Boolean);
    return department.join(', ');
  }

  const getAccessLevel = (roles) => {
    const accessLevel = roles?.map((item) => {
      const itemRoleNameSplit = item.roleName.split('/*/');
      if (itemRoleNameSplit.length > 1) {
         return itemRoleNameSplit[1]
      }
    }).filter(Boolean);
    if(accessLevel.includes('Admin')) return 'Admin';
    if(accessLevel.includes('Editor')) return 'Editor';
    if(accessLevel.includes('Viewer')) return 'Viewer';
  }

  return (
    <>
      <Box sx={{ width: '100%', borderRadius: '10px' }} className='px-8'>
        <Paper sx={{ width: '100%', mb: 2, borderRadius: '10px' }}>
          <TableContainer sx={{borderRadius: '10px'}}>
            <Table
              aria-labelledby="tableTitle"
              size={'medium'}
              sx={{ minWidth: 750, borderRadius: '10px' }}
            >
              <EnhancedTableHead
                headCells={headCells}
                totalRecords={totalRecords}
              />
              <TableBody>
                {user?.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}${row.userId}`;
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      tabIndex={-1}
                      sx={{
                        cursor: checkFeatureFeasbility(FEATURE_NAME.UPDATE_SPOC, userFeatures)
                          ? 'pointer'
                          : 'default'
                      }}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 items-center sticky left-0 bg-white z-10"
                        sx={{
                          borderRight: '1px solid #ddd',
                          justifyContent: 'center'
                        }}
                      >
                        <div className="flex gap-2  items-center w-full">
                          <div className="flex flex-col flex-1">
                            <p className=' text-sm font-medium underline decoration-mb-blue-400 text-mb-blue-400'
                              onClick={(e) => { 
                                (checkFeatureFeasbility(FEATURE_NAME.UPDATE_SPOC, userFeatures)) && handleClickOpen(row?.userId, row?.entityId, row?.userName) 
                              }}
                            >
                            {row?.firstName} {row?.lastName}
                            </p>
                            <p className="text-s text-gray-500 ">
                              {row?.userId}
                            </p>
                          </div>
                          {(checkFeatureFeasbility(FEATURE_NAME.UPDATE_SPOC, userFeatures)) && <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => {handleClickOpen(row?.userId, row?.entityId, row?.userName) }} style={{ cursor: 'pointer' }} />}
                        </div>
                      </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', justifyContent: 'center' }} > {getAccessLevel(row.roles)} </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', justifyContent: 'center' }} > <div className=""> <SPOCProfileButton profileStatus={row.isActive} userId={row.userId} userName={row.userName} providerMasterEntityId={row?.entityId} fetchSPOCDetails={fetchSPOCDetails} /> </div> </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', justifyContent: 'center' }} >{getServicesFromRoles(row.roles)}</TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', width: '320px', justifyContent: 'center' }}>
                        <Tooltip
                          title=
                          {
                            <React.Fragment>
                              <p className=' text-normal font-normal'>
                                {getDepartmentFromRoles(row.roles)}
                              </p>
                            </React.Fragment>
                          }>
                          <div className="w-full overflow-hidden line-clamp-2 whitespace-pre-wrap break-words">
                            {getDepartmentFromRoles(row.roles)}
                          </div>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', justifyContent: 'center' }} >{row.providerName} </TableCell>
                      <TableCell align="left"
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 justify-center"
                        sx={{ borderRight: '1px solid #ddd' }}>
                        <LastModfiedCell doctorModifiedOn={row.updatedOn} doctorModifiedBy={row.modifiedBy} />
                      </TableCell>

                      <TableCell align="left"
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 justify-center">
                     < MenuListComposition createdOn={row.createdOn} createdBy={row.createdByUser} userName={row.userName} entityId={row?.entityId}/>
                     </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (60) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <div className="flex relative justify-end w-full items-end px-8 py-4 ">
        <TablePagination setPage={setPage} page={page} totalRecords={totalRecords} />
      </div>
    </>

  );
}